import styled from '@emotion/styled/macro';
import { SidePanel } from '../messaging/side-panel';
import { Variables } from '../base/variables';

const V = Variables.ThemeLight;

/**
 * Above MUI's modal layer (1300), as the Roster and payer drawers are: at `SidePanel`'s own 1200 an
 * invisible popover backdrop the table leaves mounted can sit on top and swallow every click.
 */
export const Panel = styled(SidePanel)`
    z-index: 1400;
`;

export const Sheet = styled.div`
    outline: none;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    background: ${V.Background3};
`;

export const Header = styled.header`
    flex: none;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 16px 20px;
    border-bottom: 1px solid ${V.Border1};
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

export const IconBox = styled.span`
    flex: none;
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 1px solid ${V.Border1};
    background: ${V.Background1};
    color: ${V.TextMedium};
`;

export const Titles = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 17px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 1.3;
    color: ${V.TextStrong};
    overflow-wrap: anywhere;
`;

export const Subtitle = styled.div`
    margin-top: 2px;
    font-size: 13px;
    color: ${V.TextMild};
`;

export const Actions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const Body = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 20px;
`;
